import { mapActions } from 'vuex';

import Events from '_utils/events';
import ProductService from '_services/rest/modules/product';
import { _OPEN_MODAL_, _RELOAD_SAMPLE_AGENT_, MODAL_TYPE } from '_modules/sample/components/SampleModel';

export default {
  data() {
    return {
      agents: [],
    };
  },
  methods: {
    ...mapActions(['setToggle']),
    async getListAgents(name = '', slug) {
      try {
        this.toggleLoading();
        const params = {
          skip: 0,
          take: 10,
          search: name,
          slug,
        };
        const response = await ProductService.getList(params);
        this.agents = response.list;
      } finally {
        this.toggleLoading();
      }
    },
    setAutocompleteValue(refName, value) {
      const autocomplete = this.$refs[refName];
      const input = autocomplete?.$refs?.input;
      if (input && value) {
        input.value = value;
      }
    },
    openModalEditAgent(agentId, index = null) {
      this.setToggle({ type: MODAL_TYPE, bool: true });
      Events.$emit(_OPEN_MODAL_, { agentId, index, type: MODAL_TYPE });
    },
    handleReloadSampleAgent(agent) {
      this.setAgentData(agent);
    },
  },
  mounted() {
    Events.$on(_RELOAD_SAMPLE_AGENT_, this.handleReloadSampleAgent);
  },
  beforeDestroy() {
    Events.$off(_RELOAD_SAMPLE_AGENT_, this.handleReloadSampleAgent);
  },
};
